import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { RenameModalComponent } from './rename-modal/rename-modal.component';
import { Vector as VectorLayer } from 'ol/layer';
import { Vector as VectorSource } from 'ol/source';
import { Style } from 'ol/style';
import { MultiDeleteBookmarkComponent } from './multi-delete-bookmark/multi-delete-bookmark.component';
import { wmsLayer } from '../../map/wms_layers';
import { HttpClient } from '@angular/common/http';
import { BookMarkService } from 'src/app/modules/map/services/Bookmark/book-mark.service';
import { GlobalService } from 'src/app/services/global.service';
import { MapServiceService } from '../../../services/Map-service/map-service.service';
import { SideNavService } from '../../../services/sidenav/side-nav.service';
import { BookMarkFolderSystemService } from '../../../services/bookmark-folder/book-mark-folder-system.service';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-bookmark',
  templateUrl: './bookmark.component.html',
  styleUrls: ['./bookmark.component.css'],
})
export class BookmarkComponent implements OnInit {
  value: any;
  val: any;
  isActive: any = [];
  mainFolderActive = false;
  createFolderPop = false;
  showBookMark: any;
  show: any;
  hideShowPanel: any;
  clicked: any = [];
  showFolder: any;
  folderId: any;
  extentTap: any;
  parcel: any;
  singleClickedFolder = false;
  overFlow = false;
  deleteFolderModal = false;
  selectDisable = false;
  bookMarkArr: any = [];
  bookmarkFolder: any = [];
  counters: any = [];
  listId: any = [];
  click: any;
  active: any[] = [];
  bookMarkDrawSource: any;

  globalIndex: any;

  saveView: any;
  bookMarkDrawLayer: any;
  draw: any;
  json: any;
  subText: any;
  title: any;
  rmInteraction: any;
  bookMarkfeature: any;
  sketch: any;
  pointGeometry: any;
  polygonGeometry: any;
  mapId: any;
  layersId: any;
  layers: any;
  parcelLength = '1';
  slectedUnion = '1';
  ctrlCheck = 'false';
  polygonAnnotation = 'false';
  removeFolder = '<Remove>';
  linesAnnotation = 'false';
  pointSAnnotation = 'false';
  mapResolution = '152.87405654907226';
  eventName: any;
  selectedFeatures: any;
  panelState: any = [];
  multipleParcel = false;
  clickedIndexForFont: any;
  mapName = 'google-hybrid';
  singleId: any = [];
  logEvent: any;
  point: any;
  wkt: any;
  saveVieTitle: any;
  extent: any;
  xmin: any;
  xmax: any;
  ymin: any;
  ymax: any;
  zoom: any;
  lat: any;
  lon: any;
  pointLabel: any;
  multiparcel: any;
  parcelIds: any;
  showDefaultMark = true;
  editFolder = false;
  hidePanel = false;
  featureLayerId: any;
  getMarkBook: any;
  enabled_overlay: any[] = [];
  selectIndex: any = [];
  allBookMarks: any;
  bookMarkFolderView: any;
  defaultBookMark: any;
  reBookMark: any;
  preSelected = false;
  selectedIndexId: any;
  delBookMark: any;
  iconVisible: any;
  setDefault = false;
  buttonName: any = 'set';
  viewId: any;
  mapCode: any;
  titleBookMark: any;
  methodType: any;
  overlayLayer: any;
  selectedRow: any;
  selectedFeature: any = '';
  delBody: any;
  clickedIndex: any;
  clickedIndexFolder: any;
  defaultView: any;
  checkDefault: any;
  defaultSet: any;
  headingShow: any;
  status: any;
  html: any;
  eventLogName: any;
  ClickBookMark: any;
  resetId: any;
  showDeleteIcon = false;
  default: any;
  setValue: any;
  match: any;
  uniqueName: any;
  counter: any;
  copy: any;
  check: any;
  messagedefaultBookMark: any = {};
  showdefaultBookMark: any = {};
  togglePanel: any = {};
  showText: any;
  zoomSave: any;
  openFoldersPanel: any = false;
  openPanels: any = false;
  constructor(
    private dialog: MatDialog,
    public sideNavService: SideNavService,
    public bookMarkService: BookMarkService,
    private globalService: GlobalService,
    public mapService: MapServiceService,
    private cd: ChangeDetectorRef,
    private http: HttpClient,
    public folderService: BookMarkFolderSystemService,
    public auth: AuthService
  ) {}

  ngOnInit(): void {
    this.click = false;
    this.mapService.getLayersId();
    this.showDeleteIcon = false;
    if (this.mapService.mainFolder) {
      this.mainFolderActive = this.mapService.mainFolder;
      this.mainFodler();
    }

    // this.html = this.mapService.accessMapApi.map_data.map_data.tool_desc['save-view']
    if (
      !this.mapService.accessMapApi.map_data.map_data.tool_desc['save-view']
    ) {
      this.html = '';
    } else {
      this.html =
        this.mapService.accessMapApi.map_data.map_data.tool_desc['save-view'];
    }
    this.overlayLayer = this.mapService.getLayersId().toString();
    this.bookMarkDrawSource = new VectorSource();
    this.bookMarkDrawLayer = new VectorLayer({
      source: this.bookMarkDrawSource,
    });
    if (!this.mapService.baseLayerName) {
      this.mapService.baseLayerName = this.mapName;
    } else {
      this.mapService.baseLayerName;
    }
    this.mapService.mapLayer.addLayer(this.bookMarkDrawLayer);
    this.layers = this.mapService.mapData.map_data.map_data.layers;
    this.layersId = this.mapService.getLayersId().toString();
    this.mapId = this.mapService.mapData.map_data.map_data.id.toString();
    this.mapService.currentZoom.subscribe((data: any) => {
      this.zoom = data;
    });
    this.point = this.mapService.pointGeometry;
    this.wkt = this.mapService.polygonGeometry;
    this.mapService.setPolygon.subscribe((res: any) => {
      this.wkt = res;
    });
    this.mapService.setPoint.subscribe((res: any) => {
      this.point = res;
    });
    this.mapService.zoomSaveView =
      this.mapService.mapLayer.getView().getZoom() -
      this.mapService.mapsData.minzoom;
    this.getAllBoobkMArk();
    //edit annotation

    this.sideNavService.renameBookMarkData.subscribe((res: any) => {
      this.editbookMark(res);
    });
    this.sideNavService.renameBookMarkFolder.subscribe((res: any) => {
      this.showFolder = -1;
      this.editbookMarkFolder(res);
    });
    this.sideNavService.deleteBookMarkData.subscribe((res: any) => {
      this.showFolder = -1;
      this.deleteBookMark(res);
    });
    this.mapService.defaultValue.subscribe((res: any) => {
      this.status = res;
    });
    this.mapService.bookMarkMsg.subscribe((res: any) => {
      this.showDefaultMark = res;
    });
    this.mapService.refreshBookMark.subscribe((res: any) => {
      if (res) {
        this.getAllBoobkMArk();
      }
    });
    const lonLat = this.mapService.mapLayer.getView().getCenter();
    this.lat = lonLat[1];
    this.lon = lonLat[0];
    this.defaultView = this.mapService.mapData.map_data.default_view;
    this.defaultSet = this.defaultView.default_set;
    if (this.defaultSet === false) {
      this.status = `${'Set'}`;
    } else {
      this.status = `${'Reset'}`;
    }
    this.setDefault = this.defaultView.set_default;
    if (this.setDefault === true) {
      this.layersId = this.defaultView.overlay;
      this.pointGeometry = this.defaultView.point;
      this.wkt = this.defaultView.wkt;
      if (!this.pointGeometry && !this.polygonGeometry) {
        return;
      } else {
        this.getAdvanceSelect();
      }
    }
    // this.activeButton(this.folderService.setSate)

    if (
      this.folderService.setbookMarkSateName &&
      this.folderService.setbookMarkSateInedx
    ) {
      this.clickToZoomFolder(
        null,
        this.folderService.setbookMarkSateName,
        this.folderService.setbookMarkSateInedx
      );
    }
    if (this.folderService.defaultView) {
      this.setDefaultView(this.folderService.defaultView);
    }
  }
  editbookMark(res: any) {
    for (let i = 0; i < this.allBookMarks.length; i++) {
      if (res.id == this.allBookMarks[i].id) {
        this.allBookMarks[i].view_label = res.view_label;
        this.sideNavService.allBookMarks = this.allBookMarks;
        break;
      }
    }
  }
  editbookMarkFolder(res: any) {
    for (let i = 0; i < this.bookMarkFolderView.length; i++) {
      if (res.id == this.bookMarkFolderView[i].id) {
        this.bookMarkFolderView[i].title = res.title;
        this.bookMarkFolderView[i].sub_title = res.sub_title;
        this.bookMarkFolderView;
        break;
      }
    }
  }
  deleteBookMark(res: any) {
    if (res === 'deleteFolder') {
      for (let i = 0; i < this.bookMarkFolderView.length; i++) {
        if (
          this.bookMarkFolderView[i].id == this.bookMarkService.folderData.id
        ) {
          this.bookMarkFolderView.splice(i, 1);
          this.bookMarkFolderView;
        }
      }
    } else {
      const source = this.bookMarkDrawLayer.getSource();
      const features = this.bookMarkDrawSource.getFeatures();
      for (let i = 0; i < features.length; i++) {
        for (let i = 0; i < res.length; i++) {
          if (features[i].get('id') == res[i].id) {
            features[i].setStyle(new Style({}));
            features[i].set('visible', false);
            source.removeFeature(features[i]);
          }
        }
      }
      if (res.length > 0) {
        const ids = [];
        const folderIds = [];
        for (let i = 0; i < this.allBookMarks.length; i++) {
          ids.push(this.allBookMarks[i].id);
        }
        for (let i = 0; i < this.bookMarkFolderView.length; i++) {
          for (let j = 0; j < this.bookMarkFolderView[i].bookmark.length; j++) {
            folderIds.push(this.bookMarkFolderView[i].bookmark[j].id);
          }
        }
        for (let i = 0; i < res.length; i++) {
          if (ids.includes(res[i].id)) {
            const index = this.allBookMarks.findIndex(
              (item: any) => item.id === res[i].id
            );
            this.allBookMarks[index].visible = false;
            this.allBookMarks.splice(index, 1);
            this.sideNavService.allBookMarks = this.allBookMarks;
          }
        }
        for (let i = 0; i < res.length; i++) {
          if (folderIds.includes(res[i].id)) {
            for (let j = 0; j < this.bookMarkFolderView.length; j++) {
              for (
                let k = 0;
                k < this.bookMarkFolderView[j].bookmark.length;
                k++
              ) {
                if (this.bookMarkFolderView[j].bookmark[k].id === res[i].id) {
                  this.bookMarkFolderView[j].bookmark[k].visible = false;
                  this.bookMarkFolderView[j].bookmark.splice(k, 1);
                }
              }
            }
          }
        }
      } else {
        for (let i = 0; i < this.allBookMarks.length; i++) {
          if (this.allBookMarks[i].id == res.id) {
            this.allBookMarks[i].visible = false;
            this.allBookMarks.splice(i, 1);
            this.sideNavService.allBookMarks = this.allBookMarks;
          }
        }
        for (let j = 0; j < this.bookMarkFolderView.length; j++) {
          for (let k = 0; k < this.bookMarkFolderView[j].bookmark.length; k++) {
            if (this.bookMarkFolderView[j].bookmark[k].id === res.id) {
              this.bookMarkFolderView[j].bookmark[k].visible = false;
              this.bookMarkFolderView[j].bookmark.splice(k, 1);
            }
          }
        }
      }
    }
  }

  rename(name: any): void {
    this.click = false;
    this.dialog.open(RenameModalComponent, {
      data: {
        id: name.id,
        value: name.view_label,
      },
    });
    this.click = [];
    this.show = '';
    this.selectIndex = [];
  }

  setDefaultView(data: any): void {
    this.folderService.defaultView = data;
    if (this.status === 'Set') {
      this.viewId = '';
      this.mapCode = '';
      this.viewId = data.id;
      this.mapCode = data.map;
      this.methodType = 'set';
      this.active = [];
      this.show = '';
      this.selectIndex = [];
      this.hideShowPanel = null;
      // this.active[i] = true;
      this.click = false;
    } else {
      this.viewId = '';
      this.mapCode = '';
      this.selectedRow = '';
      this.viewId = data.id;
      this.mapCode = data.map;
      this.methodType = 'reset';
      this.active = [];
      // this.active[i] = true;
      this.click = false;
      this.show = '';
      this.selectIndex = [];
      this.hideShowPanel = null;
    }
    this.show = '';
    this.selectIndex = [];
    this.getDefaultBookMark();
  }

  delete(): void {
    // this.click = false;
    // this.dialog.open(DeleteModalComponent, {
    //   data: {
    //     id: this.listId.length ? this.listId : this.singleId,
    //     status: false,
    //     type: 'bookMark',
    //   },
    // });
    // this.click = [];
    this.show = '';
    // this.selectIndex = [];
    this.deleteMultiple();
  }

  getUniqueName(newName: any) {
    this.match = true;
    this.uniqueName = newName;
    this.counter = 1;
    this.copy = true;
    while (this.match) {
      this.check = false;
      for (const j in this.allBookMarks) {
        if (this.allBookMarks[j].view_label == this.uniqueName)
          this.check = true;
      }
      if (this.check) {
        if (this.copy) {
          this.uniqueName = newName = newName + '-copy';
          this.copy = false;
        } else {
          this.uniqueName = newName + this.counter;
          this.counter++;
        }
      } else {
        this.match = false;
      }
    }
    this.saveVieTitle = this.uniqueName;
  }
  getBookMark() {
    this.eventLogName = `${'Save'}+${'bookmark'}`;
    this.getUniqueName(this.value);
    this.xmin = '';
    this.ymin = '';
    this.xmax = '';
    this.ymax = '';
    const bounds = this.mapService.mapLayer
      .getView()
      .calculateExtent(this.mapService.mapLayer.getSize());
    for (let i = 0; i < bounds.length; i++) {
      if (i == 0) {
        this.xmin = bounds[i];
      } else if (i == 1) {
        this.xmax = bounds[i];
      } else if (i == 2) {
        this.ymin = bounds[i];
      } else if (i == 3) {
        this.ymax = bounds[i];
      }
    }
    this.overlayLayer = this.mapService.getLayersId().toString();

    if (!this.wkt) {
      this.wkt = '';
    }
    if (!this.point) {
      this.point = '';
    }
    if (!this.mapService.parcel) {
      this.mapService.parcel = '';
    }
    if (!this.mapService.featureLayerId) {
      this.mapService.featureLayerId = '0';
    }
    if (!this.saveVieTitle) {
      this.saveVieTitle = '';
    }
    if (this.mapService.multiParcelId.length > 1) {
      this.mapService.multiParcel = true;
    } else {
      this.mapService.multiParcel = false;
    }
    this.mapService.innerBuffer;
    const body = {
      xmin: this.xmin.toString(),
      xmax: this.xmax.toString(),
      ymin: this.ymin.toString(),
      ymax: this.ymax.toString(),
      zoom:
        this.mapService.mapLayer.getView().getZoom() -
        this.mapService.mapsData.minzoom.toString(),
      parcel: this.mapService.parcel,
      overlay: this.overlayLayer,
      base_layer: this.sideNavService.currentLoadedMap,
      wkt: this.wkt,
      multiple_parcel: this.mapService.multiParcel,
      lon: this.lon.toString(),
      lat: this.lat.toString(),
      save_view_title: this.saveVieTitle,
      feature_layer: this.mapService.featureLayerId,
      point: this.point,
      map_id: parseInt(this.mapId),
      share_id: this.mapService.shareId.toString(),
    };
    this.json = { bookmark_label: `${this.saveVieTitle}` };
    this.json = JSON.stringify(this.json);
    this.activityLoging();
    this.bookMarkService.getBookMark(body).subscribe((res) => {
      this.globalService.toggleLoader(true);
      setTimeout(() => {
        this.value = null;
        this.getMarkBook = res;
        this.mapService.setRefreshBookMark(res);
        this.globalService.toggleLoader(false);
      }, 1000);
    });
  }

  getAllBoobkMArk() {
    this.bookMarkService.getAllBookMark(this.mapId).subscribe((res: any) => {
      this.sideNavService.allBookMarks = res.bookmarks;
      this.bookMarkFolderView = res.folders;
      for (let i = 0; i < this.bookMarkFolderView.length; i++) {
        if (this.bookMarkFolderView[i].sub_title == null) {
          this.bookMarkFolderView[i].sub_title = '';
        }
      }
      this.sideNavService.allFolders = res.folders;
      this.allBookMarks = res.bookmarks;
      this.allBookMarks.sort((a: any, b: any) => {
        return a.view_label.localeCompare(b.view_label, undefined, {
          numeric: true,
          sensitivity: 'base',
        });
      });
      for (let i = 0; i < this.bookMarkFolderView.length; i++) {
        const element = this.bookMarkFolderView[i].bookmark;
        element.sort((a: any, b: any) => {
          return a.view_label.localeCompare(b.view_label, undefined, {
            numeric: true,
            sensitivity: 'base',
          });
        });
      }

      this.bookMarkFolderView.sort((a: any, b: any) => {
        return a.title.localeCompare(b.title, undefined, {
          numeric: true,
          sensitivity: 'base',
        });
      });
    });
  }

  getDefaultBookMark() {
    const body = {
      view_id: this.viewId,
      map_id: this.mapCode,
      method_type: this.methodType,
    };
    this.bookMarkService.bookMarkDefaultView(body).subscribe((res) => {
      this.defaultBookMark = res;
      if (res.success) {
        if (res.previous === undefined) {
          this.defaultView.view_label = '';
          this.messagedefaultBookMark.id = this.viewId;
          // this.messagedefaultBookMark.previous.default_set
          this.messagedefaultBookMark.show = false;
          this.mapService.setBookMarkMsg(false);
          this.cd.detectChanges();

          this.mapService.getDefaultValue('Reset');
          this.mapService.previousLable = '';
        } else {
          this.defaultView.view_label = '';
          this.messagedefaultBookMark.id = this.defaultBookMark.new_default;
          // this.messagedefaultBookMark.id = this.defaultBookMark.all_saved_view.id;
          this.messagedefaultBookMark.show = true;

          this.mapService.setBookMarkMsg(true);
          this.cd.detectChanges();
          this.mapService.getDefaultValue('Set');

          this.mapService.previousLable = this.titleBookMark;
        }
      }
    });
  }
  changeDefault() {
    this.checkDefault = !this.setDefault;
  }

  selectMultiPleBookMark(clickEvent: any, data: any, index: any) {
    if (clickEvent.metaKey || clickEvent.ctrlKey) {
      this.singleId = [];
      if (this.preSelected) {
        // replacing all clickedIndex with globalIndex
        if (index != this.globalIndex) {
          const index2 = this.selectIndex.indexOf(this.globalIndex);
          if (index2 === -1) {
            this.selectDisable = true;
            this.selectIndex.push(this.globalIndex);
            if (this.selectIndex.length > 0) {
              this.showDeleteIcon = true;
            }
            const index3 = this.listId.indexOf(this.selectedIndexId);
            if (index3 === -1) {
              this.listId.push(this.selectedIndexId);
            }
            clickEvent.stopPropagation();
            if (!this.singleClickedFolder) {
              this.ClickBookMark = document.getElementById(
                `bookMark-${this.globalIndex}`
              );
              // this.ClickBookMark = document.getElementById(`bookMarkPanel-${index}`);
              this.ClickBookMark.style.backgroundColor = '#e5f0f9';
              this.preSelected = false;
            } else {
              this.ClickBookMark = document.getElementById(
                `bookMarkPanel-${this.selectedIndexId}`
              );
              // this.ClickBookMark = document.getElementById(`bookMarkPanel-${index}`);
              this.ClickBookMark.style.backgroundColor = '#e5f0f9';
              this.preSelected = false;
            }

            this.globalIndex = -1;
          }
        }
      }

      const index1 = this.selectIndex.indexOf(index);
      if (index1 == -1) {
        this.selectDisable = true;
        this.selectIndex.push(index);

        if (this.selectIndex.length > 0) {
          this.showDeleteIcon = true;
        }
        this.listId.push(data.id);
        clickEvent.stopPropagation();
        this.ClickBookMark = document.getElementById(`bookMark-${index}`);
        // this.ClickBookMark = document.getElementById(`bookMarkPanel-${index}`);
        this.ClickBookMark.style.backgroundColor = '#e5f0f9';
      } else {
        this.selectDisable = true;
        this.selectIndex.splice(index1, 1);
        if (this.selectIndex.length > 0) {
          this.showDeleteIcon = true;
        }
        const index2 = this.listId.indexOf(data.id);
        if (index2 !== -1) {
          this.listId.splice(index2, 1);
        }
        clickEvent.stopPropagation();
        this.resetBackground(data, index);
      }
    }
  }

  selectMultiPleBookMarkFolder(clickEvent: any, data: any, index: any) {
    if (clickEvent.metaKey || clickEvent.ctrlKey) {
      this.singleId = [];
      if (this.preSelected) {
        // replacing all clickedIndex with globalIndex
        if (index != this.globalIndex) {
          const index2 = this.selectIndex.indexOf(this.globalIndex);
          if (index2 === -1) {
            this.selectDisable = true;
            this.selectIndex.push(this.globalIndex);
            if (this.selectIndex.length > 0) {
              this.showDeleteIcon = true;
            }
            const index3 = this.listId.indexOf(this.selectedIndexId);
            if (index3 === -1) {
              this.listId.push(this.selectedIndexId);
            }

            if (!this.singleClickedFolder) {
              this.ClickBookMark = document.getElementById(
                `bookMark-${this.globalIndex}`
              );
              // this.ClickBookMark = document.getElementById(`bookMarkPanel-${index}`);
              this.ClickBookMark.style.backgroundColor = '#e5f0f9';
              this.preSelected = false;
            } else {
              this.ClickBookMark = document.getElementById(
                `bookMarkPanel-${this.selectedIndexId}`
              );
              // this.ClickBookMark = document.getElementById(`bookMarkPanel-${index}`);
              this.ClickBookMark.style.backgroundColor = '#e5f0f9';
              this.preSelected = false;
            }

            clickEvent.stopPropagation();

            this.globalIndex = -1;
          }
        }
      }

      const index1 = this.selectIndex.indexOf(index);
      if (index1 == -1) {
        this.selectDisable = true;
        this.selectIndex.push(index);
        if (this.selectIndex.length > 0) {
          this.showDeleteIcon = true;
        }
        this.listId.push(data.id);
        clickEvent.stopPropagation();
        this.ClickBookMark = document.getElementById(
          `bookMarkPanel-${data.id}`
        );
        this.ClickBookMark.style.backgroundColor = '#e5f0f9';
      } else {
        this.selectDisable = true;
        this.selectIndex.splice(index1, 1);
        if (this.selectIndex.length > 0) {
          this.showDeleteIcon = true;
        }
        const index2 = this.listId.indexOf(data.id);
        if (index2 !== -1) {
          this.listId.splice(index2, 1);
        }
        clickEvent.stopPropagation();
        this.resetBackgroundFolder(data, index);
      }
    }
  }

  resetBackgroundFolder(bookMarkData: any, index: any) {
    for (let i = 0; i < this.bookMarkFolderView.length; i++) {
      for (let j = 0; j < this.bookMarkFolderView[i].bookmark.length; j++) {
        if (
          this.bookMarkFolderView[i].bookmark[j].view_label ===
          bookMarkData.view_label
        ) {
          this.resetId = document.getElementById(
            `bookMarkPanel-${this.bookMarkFolderView[i].bookmark[j].id}`
          );
          this.resetId.style.backgroundColor = '#ffffff';
        }
      }
    }
    for (let i = 0; i < this.selectIndex.length; i++) {
      if (this.selectIndex[i] === index) {
        this.selectIndex.splice(i, 1);
      }
    }
    if (this.selectIndex.length == 0) {
      this.showDeleteIcon = false;
    }
  }
  resetBackground(bookMarkData: any, index: any) {
    for (let i = 0; i < this.allBookMarks.length; i++) {
      if (this.allBookMarks[i].view_label === bookMarkData.view_label) {
        this.resetId = document.getElementById(`bookMark-${i}`);
        this.resetId.style.backgroundColor = '#ffffff';
      }
    }
    for (let i = 0; i < this.selectIndex.length; i++) {
      if (this.selectIndex[i] === index) {
        this.selectIndex.splice(i, 1);
      }
    }
    if (this.selectIndex.length == 0) {
      this.showDeleteIcon = false;
    }
  }
  showPanel(i: any, bookMarkList: any): void {
    this.folderService.bookMarkViews = [];
    this.folderService.bookMarkViews.push(bookMarkList.id);
    this.clickedIndexForFont = i;
    this.singleId = [bookMarkList.id];

    this.selectIndex = [];
    // this.showDeleteIcon = false;
    if (this.show === i) {
      this.show = -1;
      this.overFlow = false;
    } else {
      this.show = i;
      this.overFlow = true;
    }

    this.selectIndex = [];
    if (
      bookMarkList.view_label == this.defaultView.id ||
      bookMarkList.view_label == this.mapService.previousLable
    ) {
      this.status = `${'Reset'}`;
      this.titleBookMark = '';
      this.defaultView.id = null;
    } else {
      this.status = `${'Set'}`;
      this.titleBookMark = '';
      this.titleBookMark = bookMarkList.view_label;
    }
  }
  showPanelFolder(i: any, bookMarkList: any): void {
    this.folderService.bookMarkViews = [];
    this.folderService.bookMarkViews.push(bookMarkList.id);
    this.clickedIndexForFont = i;

    this.selectIndex = [];
    // this.showDeleteIcon = false;
    if (this.hideShowPanel === bookMarkList.id) {
      this.hideShowPanel = null;
      this.clicked = [];
    } else {
      this.clicked = [];
      this.clicked[bookMarkList.id] = !this.clicked[bookMarkList.id];
      this.hideShowPanel = bookMarkList.id;
    }

    this.selectIndex = [];
    if (
      bookMarkList.view_label == this.defaultView.id ||
      bookMarkList.view_label == this.mapService.previousLable
    ) {
      this.status = `${'Reset'}`;
      this.titleBookMark = '';
      this.defaultView.id = null;
    } else {
      this.status = `${'Set'}`;
      this.titleBookMark = '';
      this.titleBookMark = bookMarkList.view_label;
    }
  }
  showFolderPanel(i: any, bookMarkList: any): void {
    if (this.showFolder === i) {
      this.showFolder = -1;
      this.hidePanel = false;
      this.editFolder = false;
      this.deleteFolderModal = false;
    } else {
      this.showFolder = i;
      this.hidePanel = true;
      this.editFolder = false;
      this.deleteFolderModal = false;
    }
    this.bookMarkService.folderData = bookMarkList;
  }
  deleteMultiple() {
    // this.showDeleteIcon = false;
    // this.resetBackground();

    // unique
    this.listId = this.listId.filter(
      (v: any, i: any) => this.listId.indexOf(v) == i
    );

    this.dialog.open(MultiDeleteBookmarkComponent, {
      data: {
        ids: this.listId.length ? this.listId : this.singleId,
        status: false,
        type: 'bookMark',
      },
    });
    // this.listId = [];
    // this.selectIndex = [];
  }

  clearAllSelectionsForDelete(): void {
    for (let i = 0; i < i + 1; i++) {
      const id: any = document.getElementById(`bookMark-${i}`);
      if (id) {
        id.style.backgroundColor = 'white';
      } else {
        break;
      }
    }

    for (let k = 0; k < this.bookMarkFolderView.length; k++) {
      for (let j = 0; j < this.bookMarkFolderView[k].bookmark.length; j++) {
        this.resetId = document.getElementById(
          `bookMarkPanel-${this.bookMarkFolderView[k].bookmark[j].id}`
        );
        if (this.resetId) {
          this.resetId.style.backgroundColor = '#ffffff';
        }
      }
    }
  }

  clickToZoom(event: any, name: any, index: any) {
    if (!(event.metaKey || event.ctrlKey)) {
      this.clearAllSelectionsForDelete();
      this.singleClickedFolder = false;
      this.listId = [];
      this.selectIndex = [];
      this.singleId = [name.id];
      this.preSelected = true;
      this.selectedIndexId = name.id;
      this.mapService.setBaseMapOnClicktoZoom(name.base_layer);
      this.clickedIndexFolder = '';
      this.clickedIndex = index;
      this.globalIndex = index;
      this.mapService.setbookMarkZoom = true;

      this.sideNavService.closeRightSideNav();
      this.extentTap = [
        +name.xmin_bound,
        +name.xmax_bound,
        +name.ymin_bound,
        +name.ymax_bound,
      ];
      this.mapService.mapLayer.getView().fit(this.extentTap);
      this.mapService.mapLayer
        .getView()
        .setZoom(this.mapService.mapsData.minzoom + name.zoom);
      this.mapId = name.map.toString();
      this.layersId = name.feature_layer;
      this.pointLabel = name.point;
      this.point = name.point;
      this.wkt = name.wkt;
      this.pointGeometry = name.point;
      this.parcelIds = name.parcel;
      this.featureLayerId = name.feature_layer;
      this.multiparcel = name.multiple_parcel;
      this.mapService.bookMarkShowLayers = [];
      this.mapService.ChangeLayerClickToZoom = [];
      this.mapService.overLayId = name.overlay.split(',');

      this.mapService.overLayIds = this.mapService.overLayIds.concat(
        this.mapService.overLayId
      );
      for (let i = 0; i < this.mapService.overLayIds.length; i++) {
        for (let j = 0; j < this.layers.length; j++) {
          if (this.mapService.overLayIds[i] == this.layers[j].id) {
            let li = null;
            const ld = this.layers[j];
            switch (ld.map.format) {
              case 'WMS':
                li = wmsLayer(
                  ld,
                  this.sideNavService.currentLoadedMap,
                  j,
                  this.auth.user ? this.auth.user.user.id : 0
                );
                break;
              case 'WIND':
                li = wmsLayer(
                  ld,
                  this.mapService.baseLayerName,
                  j,
                  this.auth.user ? this.auth.user.user.id : 0
                );
                break;
              default:
                continue;
            }
            li.setProperties({ mapport: ld, heading: ld['heading'] });
            li.setProperties({ title: ld.name });
            li.setProperties({ isVisible: false });
            li.setProperties({ isChecked: false });
            const temp = li.getProperties();
            temp.mapport.map.visible = false;
            li.setProperties({ mapport: temp.mapport });
            this.mapService.layersData.push(li);
            const headingTitle = ld.name;
            const checked = true
            const id= ld.id
            const data = {
              headingTitle,id,checked
            };
            this.mapService.ChangeLayerClickToZoom.push(data);
            this.mapService.bookMarkShowLayers.push(ld.legend.heading);
            this.mapService.bookMarkShowLayers = [
              ...new Set(this.mapService.bookMarkShowLayers),
            ];
          }
        }
      }
      this.mapService.setLayerHeadingForbookMarkClose(
        this.mapService.bookMarkShowLayers
      );
      this.mapService.bookMarkShowLayers = [];
      this.mapService.ChangeLayerClickToZoom = [];
      for (let i = 0; i < this.mapService.overLayId.length; i++) {
        for (let j = 0; j < this.layers.length; j++) {
          if (this.mapService.overLayId[i] == this.layers[j].id) {
            let li = null;
            const ld = this.layers[j];
            switch (ld.map.format) {
              case 'WMS':
                li = wmsLayer(
                  ld,
                  this.sideNavService.currentLoadedMap,
                  j,
                  this.auth.user ? this.auth.user.user.id : 0
                );
                break;
              case 'WIND':
                li = wmsLayer(
                  ld,
                  this.mapService.baseLayerName,
                  j,
                  this.auth.user ? this.auth.user.user.id : 0
                );
                break;
              default:
                continue;
            }
            li.setProperties({ mapport: ld, heading: ld['heading'] });
            li.setProperties({ title: ld.name });
            li.setProperties({ isVisible: true });
            li.setProperties({ isChecked: true });
            const temp = li.getProperties();
            temp.mapport.map.visible = true;
            li.setProperties({ mapport: temp.mapport });
            this.mapService.layersData.push(li);
            const headingTitle = ld.name;
            const checked = true
            const id= ld.id
            const data = {
              headingTitle,id,checked
            };
            this.mapService.ChangeLayerClickToZoom.push(data);
            this.mapService.bookMarkShowLayers.push(ld.legend.heading);
            this.mapService.bookMarkShowLayers = [
              ...new Set(this.mapService.bookMarkShowLayers),
            ];
          }
        }
      }
      this.mapService.setChangeLayerClickToZoom(
        this.mapService.ChangeLayerClickToZoom
      );
      this.mapService.setLayerHeadingForbookMark(
        this.mapService.bookMarkShowLayers
      );
      this.parcelSearch();
    }
  }

  clickToZoomFolder(event: any = false, name: any, index: any) {
    if (!(event.metaKey || event.ctrlKey)) {
      this.clearAllSelectionsForDelete();
      this.listId = [];
      this.selectIndex = [];
      this.singleClickedFolder = true;
      this.singleId = [name.id];
      this.preSelected = true;
      this.selectedIndexId = name.id;
      this.mapService.setBaseMapOnClicktoZoom(name.base_layer);
      this.clickedIndexFolder = index;
      this.folderService.setbookMarkSateInedx = this.clickedIndexFolder;
      this.folderService.setbookMarkSateName = name;
      this.clickedIndex = '';
      this.globalIndex = index;
      this.mapService.setbookMarkZoom = true;

      this.sideNavService.closeRightSideNav();
      this.extentTap = [
        +name.xmin_bound,
        +name.xmax_bound,
        +name.ymin_bound,
        +name.ymax_bound,
      ];
      this.mapService.mapLayer.getView().fit(this.extentTap);
      this.mapService.mapLayer
        .getView()
        .setZoom(this.mapService.mapsData.minzoom + name.zoom);
      this.mapId = name.map.toString();
      this.layersId = name.feature_layer;
      this.pointLabel = name.point;
      this.point = name.point;
      this.wkt = name.wkt;
      this.pointGeometry = name.point;
      this.parcelIds = name.parcel;
      this.featureLayerId = name.feature_layer;
      this.multiparcel = name.multiple_parcel;
      this.mapService.bookMarkShowLayers = [];
      this.mapService.ChangeLayerClickToZoom = [];
      this.mapService.overLayId = name.overlay.split(',');

      this.mapService.overLayIds = this.mapService.overLayIds.concat(
        this.mapService.overLayId
      );
      for (let i = 0; i < this.mapService.overLayIds.length; i++) {
        for (let j = 0; j < this.layers.length; j++) {
          if (this.mapService.overLayIds[i] == this.layers[j].id) {
            let li = null;
            const ld = this.layers[j];
            switch (ld.map.format) {
              case 'WMS':
                li = wmsLayer(
                  ld,
                  this.sideNavService.currentLoadedMap,
                  j,
                  this.auth.user ? this.auth.user.user.id : 0
                );
                break;
              case 'WIND':
                li = wmsLayer(
                  ld,
                  this.mapService.baseLayerName,
                  j,
                  this.auth.user ? this.auth.user.user.id : 0
                );
                break;
              default:
                continue;
            }
            li.setProperties({ mapport: ld, heading: ld['heading'] });
            li.setProperties({ title: ld.name });
            li.setProperties({ isVisible: false });
            li.setProperties({ isChecked: false });
            const temp = li.getProperties();
            temp.mapport.map.visible = false;
            li.setProperties({ mapport: temp.mapport });
            this.mapService.layersData.push(li);
            const headingTitle = ld.name;
            const checked = true
            const id= ld.id
            const data = {
              headingTitle,id,checked
            };
            this.mapService.ChangeLayerClickToZoom.push(data);
            this.mapService.bookMarkShowLayers.push(ld.legend.heading);
            this.mapService.bookMarkShowLayers = [
              ...new Set(this.mapService.bookMarkShowLayers),
            ];
          }
        }
      }
      this.mapService.setLayerHeadingForbookMarkClose(
        this.mapService.bookMarkShowLayers
      );
      this.mapService.bookMarkShowLayers = [];
      this.mapService.ChangeLayerClickToZoom = [];
      for (let i = 0; i < this.mapService.overLayId.length; i++) {
        for (let j = 0; j < this.layers.length; j++) {
          if (this.mapService.overLayId[i] == this.layers[j].id) {
            let li = null;
            const ld = this.layers[j];
            switch (ld.map.format) {
              case 'WMS':
                li = wmsLayer(
                  ld,
                  this.sideNavService.currentLoadedMap,
                  j,
                  this.auth.user ? this.auth.user.user.id : 0
                );
                break;
              case 'WIND':
                li = wmsLayer(
                  ld,
                  this.mapService.baseLayerName,
                  j,
                  this.auth.user ? this.auth.user.user.id : 0
                );
                break;
              default:
                continue;
            }
            li.setProperties({ mapport: ld, heading: ld['heading'] });
            li.setProperties({ title: ld.name });
            li.setProperties({ isVisible: true });
            li.setProperties({ isChecked: true });
            const temp = li.getProperties();
            temp.mapport.map.visible = true;
            li.setProperties({ mapport: temp.mapport });
            this.mapService.layersData.push(li);
            const headingTitle = ld.name;
            const checked = true
            const id= ld.id
            const data = {
              headingTitle,id,checked
            };
            this.mapService.ChangeLayerClickToZoom.push(data);
            this.mapService.bookMarkShowLayers.push(ld.legend.heading);
            this.mapService.bookMarkShowLayers = [
              ...new Set(this.mapService.bookMarkShowLayers),
            ];
          }
        }
      }
      this.mapService.setChangeLayerClickToZoom(
        this.mapService.ChangeLayerClickToZoom
      );
      this.mapService.setLayerHeadingForbookMark(
        this.mapService.bookMarkShowLayers
      );
      this.parcelSearch();
    }
  }

  parcelSearch() {
    if (!this.mapService.shareId) {
      this.mapService.shareId = '';
    } else {
      this.mapService.shareId;
    }

    this.mapService
      .getParcelData(
        'parcel',
        this.parcelIds,
        parseInt(this.mapId),
        this.pointLabel,
        this.wkt,
        'false',
        this.multiparcel.toString(),
        this.featureLayerId,
        '',
        '',
        ''
      )
      .subscribe((res) => {
        this.globalService.toggleLoader(true);
        setTimeout(() => {
          this.sideNavService.decideComponent(res);
          this.globalService.toggleLoader(false);
        }, 1000);
      });
  }
  getAdvanceSelect() {
    //check for hidding data panel and then show
    if (this.sideNavService.hideRightPanelForImage) {
      this.sideNavService.closeRightSideNav();
      // this.sideNavService.showAnimateNow = false;
      this.sideNavService.hideRightPanelForImage = false;
    }
    this.globalService.toggleLoader(true);
    this.mapService.perviousLabel = '0';
    this.mapService
      .getSearchCoordinates(
        this.mapId,
        // this.layersId,
        this.mapService.getLayersId(),
        this.wkt,
        this.pointGeometry,
        this.parcelLength,
        this.slectedUnion,
        this.ctrlCheck.toString(),
        this.polygonAnnotation,
        this.linesAnnotation,
        this.pointSAnnotation,
        this.mapService.mapLayer.getView().getResolution().toString(),
        this.selectedFeature,
        this.mapService.preSelectedAnnotation,
        '',
        this.mapService.currentMapZoom
      )
      .subscribe((res) => {
        if (res.features.length) {
          this.mapService.perviousLabel =
            res.features[res.features.length - 1].label;
        }
        this.sideNavService.decideComponent(res);
        this.selectedFeatures = res.features;
        const highestLabel = this.selectedFeatures.reduce((prevObj: any, currentObj: any) => {
          return (prevObj.label > currentObj.label) ? prevObj : currentObj;
        }).label;
        this.mapService.perviousLabel = highestLabel
        for (let i = 0; i < this.selectedFeatures.length; i++) {
          this.mapService.parcel = this.selectedFeatures[i].id;
          this.mapService.featureLayerId = this.selectedFeatures[i].layer_id;
        }
      });
  }

  closeLeft() {
    this.mapService.closePanel = true;
    this.mapService.setClosePanel(true);
  }
  getPosition(i: any) {
    this.openFoldersPanel = false;
    const element = document.getElementById(`bookMark-${i}`) as HTMLElement;
    let topPos = element.getBoundingClientRect().top + window.scrollY;
    const element1 = document.getElementById(`actionMenu${i}`) as HTMLElement;
    if (typeof element !== 'undefined' && typeof element1 !== 'undefined') {
      if (window.innerHeight - topPos < 100) {
        topPos = topPos - 50;
        element1.style.top = `${topPos.toString()}px`;
      } else {
        topPos = topPos - 5;
        element1.style.top = `${topPos.toString()}px`;
      }
    }
  }

  createFolder() {
    this.title = '';
    this.subText = '';
    this.createFolderPop = true;
    setTimeout(() => {
      const element = document.getElementById('folder_icon') as HTMLElement;
      let topPos = element.getBoundingClientRect().top + window.scrollY;
      const element1 = document.getElementById('folder_menu') as HTMLElement;
      if (typeof element !== 'undefined' && typeof element1 !== 'undefined') {
        if (window.innerHeight - topPos < 100) {
          topPos = topPos - 50;
          element1.style.top = `${topPos.toString()}px`;
        } else {
          topPos = topPos - 40;
          element1.style.top = `${topPos.toString()}px`;
        }
      }
    }, 1);
  }
  save() {
    const body = {
      title: this.title,
      sub_title: this.subText,
      map: this.mapId,
      used_for: 'bookmark',
    };
    this.folderService.createBookmarkFolder(body).subscribe((res) => {
      this.mapService.setRefreshBookMark(res);
      this.dialog.closeAll();
      this.createFolderPop = false;
    });
  }

  close(): void {
    this.createFolderPop = false;
    this.editFolder = false;
    this.deleteFolderModal = false;
    this.dialog.closeAll();
  }

  openFolderPanel() {
    if (this.bookMarkFolderView.length >= 0) {
      this.openFoldersPanel = true;
    }
  }
  openFolderPanelHide() {
    if (this.bookMarkFolderView.length >= 0) {
      this.openFoldersPanel = false;
    }
  }
  openPanel() {
    this.openPanels = true;
  }
  openPanelHide() {
    this.openPanels = false;
  }
  activeButton(i: any): void {
    if (this.isActive[i]) {
      this.isActive[i] = false;
    } else {
      this.isActive[i] = true;
      // this.folderService.setSate = i
    }
  }
  updateFolder(i: any) {
    this.folderId = '';
    this.title = '';
    this.subText = '';
    (this.folderId = this.bookMarkService.folderData.id),
      (this.title = this.bookMarkService.folderData.title),
      (this.subText = this.bookMarkService.folderData.sub_title),
      (this.editFolder = true);
    setTimeout(() => {
      const element = document.getElementById(
        `actionMenuFolder${i}`
      ) as HTMLElement;
      let topPos = element.getBoundingClientRect().top + window.scrollY;
      const element1 = document.getElementById(
        `FolderExpansionMenu${i}`
      ) as HTMLElement;
      if (typeof element !== 'undefined' && typeof element1 !== 'undefined') {
        if (window.innerHeight - topPos < 100) {
          topPos = topPos - 50;
          element1.style.top = `${topPos.toString()}px`;
        } else {
          topPos = topPos - 5;
          element1.style.top = `${topPos.toString()}px`;
        }
      }
      this.hidePanel = false;
    }, 1);
  }
  saveEditFolder() {
    const body = {
      title: this.title,
      sub_title: this.subText,
    };
    this.bookMarkService
      .updatebookMarkFolder(this.folderId, body)
      .subscribe((res: any) => {
        this.dialog.closeAll();
        this.sideNavService.renameFolder(res);
        this.editFolder = false;
      });
  }
  deleteFolder(i: any) {
    this.hidePanel = true;
    this.editFolder = false;
    this.deleteFolderModal = true;
    this.bookMarkService.folderData.id;
    setTimeout(() => {
      const element = document.getElementById(
        `actionMenuFolder${i}`
      ) as HTMLElement;
      let topPos = element.getBoundingClientRect().top + window.scrollY;
      const element1 = document.getElementById(
        `FolderExpansionMenu${i}`
      ) as HTMLElement;
      if (typeof element !== 'undefined' && typeof element1 !== 'undefined') {
        if (window.innerHeight - topPos < 100) {
          topPos = topPos - 50;
          element1.style.top = `${topPos.toString()}px`;
        } else {
          topPos = topPos + 25;
          element1.style.top = `${topPos.toString()}px`;
        }
      }
    }, 1);
  }
  deleteFolderPop() {
    this.bookMarkService
      .deletbookMarkFolder(this.bookMarkService.folderData.id)
      .subscribe((res) => {
        this.dialog.closeAll();
        this.delBookMark = res;
        this.sideNavService.deleteBookMarkComponent('deleteFolder');
      });
    this.deleteFolderModal = false;
  }

  getPositionFolder(i: any) {
    this.openFoldersPanel = false;
    const element = document.getElementById(
      `bookMarkFolder-${i}`
    ) as HTMLElement;
    let topPos = element.getBoundingClientRect().top + window.scrollY;
    const element1 = document.getElementById(
      `actionMenuFolder${i}`
    ) as HTMLElement;
    if (typeof element !== 'undefined' && typeof element1 !== 'undefined') {
      if (window.innerHeight - topPos < 100) {
        topPos = topPos - 50;
        element1.style.top = `${topPos.toString()}px`;
      } else {
        topPos = topPos - 5;
        element1.style.top = `${topPos.toString()}px`;
      }
    }
  }
  getPositionPanel(i: any) {
    this.openFoldersPanel = false;
    const element = document.getElementById(
      `bookMarkPanel-${i}`
    ) as HTMLElement;
    let topPos = element.getBoundingClientRect().top + window.scrollY;
    const element1 = document.getElementById(
      `actionMenuPanel${i}`
    ) as HTMLElement;
    if (typeof element !== 'undefined' && typeof element1 !== 'undefined') {
      if (window.innerHeight - topPos < 100) {
        topPos = topPos - 50;
        element1.style.top = `${topPos.toString()}px`;
      } else {
        topPos = topPos - 5;
        element1.style.top = `${topPos.toString()}px`;
      }
    }
  }
  moveBookmark(folderID: any) {
    const body = {
      bookmark_ids: this.listId.length
        ? this.listId
        : this.folderService.bookMarkViews,
      folder_id: folderID.id,
    };
    this.folderService.moveBookmarkToFolder(body).subscribe((res: any) => {
      this.mapService.setRefreshBookMark(res);
      this.dialog.closeAll();
      this.show = -1;
      this.hideShowPanel = null;
      this.openPanels = false;
      this.openFoldersPanel = false;
    });
  }
  removeFromFolder() {
    //handling for multi moving
    const body = {
      bookmark_ids: this.listId.length
        ? this.listId
        : this.folderService.bookMarkViews,
      folder_id: null,
    };
    this.folderService.removeFromFolder(body).subscribe((res: any) => {
      this.mapService.setRefreshBookMark(res);
      this.dialog.closeAll();
      this.hideShowPanel = null;
      this.openPanels = false;
    });
  }
  mainFodler() {
    this.mainFolderActive = !this.mainFolderActive;
    this.mapService.mainFolder = this.mainFolderActive;
  }
  activityLoging() {
    this.http
      .get('https://api.ipify.org/?format=json')
      .subscribe((res: any) => {
        this.mapService.ipAddress = res.ip;
        const body = {
          map_id: this.mapId.toString(),
          event: 'Click',
          page: this.mapService.pageUrl,
          basemap: this.mapService.shareCurrentMap,
          event_name: 'Bookmark:Save',
          ip: this.mapService.ipAddress,
          time: this.mapService.getTimeOnPage().toString(),
          event_information: this.json,
          point: '',
          wkt: '',
        };
        this.mapService.activityLogs(body).subscribe(
          () => {
            //
          },
          (error: any) => {
            if (error.status == 403) {
              location.reload();
            }
          }
        );
      });
  }
}
